import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


const routes: Routes = [
    {
        path: 'Default.aspx',
        redirectTo: '/elearning',
        pathMatch: 'full'
    },
    {
        path: '',
        redirectTo: '/elearning',
        pathMatch: 'full'
    },
    { path: 'elearning', loadChildren: './elearning/elearning.module#ElearningModule' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts